var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.039 13.6469C17.0591 14.0964 16.9882 14.5453 16.8303 14.968C16.6724 15.3907 16.4306 15.7788 16.1188 16.1103C15.807 16.4417 15.4312 16.7099 15.013 16.8995C14.5947 17.0891 14.1423 17.1964 13.6816 17.2152C13.5388 17.2258 13.3953 17.2258 13.2525 17.2152H6.58065C6.12172 17.2524 5.65979 17.2004 5.22154 17.0624C4.7833 16.9245 4.37739 16.7031 4.02732 16.4112C3.67725 16.1193 3.38995 15.7627 3.18198 15.3619C2.97401 14.961 2.8495 14.524 2.81565 14.0759C2.80494 13.9331 2.80494 13.7897 2.81565 13.6469V6.32186C2.7955 5.87239 2.86641 5.42342 3.0243 5.00072C3.18219 4.57802 3.42398 4.18985 3.73582 3.85842C4.04766 3.52698 4.42345 3.25878 4.84166 3.06918C5.25987 2.87958 5.71229 2.77231 6.17304 2.75348H13.2632C14.1894 2.68683 15.1051 2.97906 15.8119 3.56672C16.5187 4.15439 16.9596 4.99012 17.039 5.89278C17.039 6.02882 17.039 6.16487 17.039 6.30091V13.6469Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0391 9.10525L21.4369 5.59972C21.6552 5.42503 21.9353 5.34132 22.2164 5.36679C22.4975 5.39226 22.757 5.52484 22.9386 5.73576C23.0985 5.92403 23.1858 6.16093 23.1853 6.40543V13.5944C23.186 13.7925 23.1291 13.9867 23.0212 14.1544C22.9133 14.3221 22.7588 14.4565 22.5757 14.5419C22.3926 14.6274 22.1884 14.6605 21.9868 14.6372C21.7852 14.614 21.5946 14.5354 21.4369 14.4107L17.0391 10.9052",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    fill: "#0FE465",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatVideo);
export default __webpack_public_path__ + "static/media/chat_video.9b0f7d9d66b2f5b3268e4a5dadcd2111.svg";
export { ForwardRef as ReactComponent };